var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGrupalIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32.871,
    height: 30.713,
    viewBox: "0 0 32.871 30.713",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_11305",
    "data-name": "Group 11305",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_11303",
    "data-name": "Group 11303",
    transform: "translate(14.091 2.226)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7118",
    "data-name": "Path 7118",
    d: "M53.508,155.327l.052-.093c-.029.009-.055.023-.083.032C53.488,155.286,53.5,155.307,53.508,155.327Z",
    transform: "translate(-48.689 -145.429)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7119",
    "data-name": "Path 7119",
    d: "M62.822,139.48a17.876,17.876,0,0,0-2,.325,11.984,11.984,0,0,0-7.064,4.518,4.527,4.527,0,0,1,.055.673,4.48,4.48,0,0,1-3.167,4.279l-.052.093a9.187,9.187,0,0,1,1.079,3.012,4.183,4.183,0,0,1-.1,1.725,3.123,3.123,0,0,1-2.5,2.311l-1.489.282-.487.091c-.463.994-.906,2-1.321,3.009q.938,2.014,1.876,4.028.1.214.175.431c.645-1.766,1.343-3.513,2.117-5.23.039-.085.081-.168.134-.279.8,1.748,1.578,3.456,2.373,5.156.47,1,.951,2,1.471,2.984a1.389,1.389,0,0,0,1.648.653,1.864,1.864,0,0,0,1.223-2.727q-1.83-3.919-3.65-7.844a2.561,2.561,0,0,1-.111-.4,4.739,4.739,0,0,0,.788-.006c1.847-.337,3.69-.69,5.534-1.037a1.159,1.159,0,0,0,.967-.884,2.158,2.158,0,0,0,.055-.875,6.8,6.8,0,0,0-.842-2.305A11.417,11.417,0,0,0,57.5,148.98a1.916,1.916,0,0,1-.234-.3c-.241-.347-2.169-1.823-.659-3.39a9.349,9.349,0,0,1,2.866-2.052,12.186,12.186,0,0,1,3.905-.994,1.133,1.133,0,0,0,1.134-.846A1.559,1.559,0,0,0,62.822,139.48ZM57.23,153.057l-2.729.515-.055-.057,1.584-2.09Z",
    transform: "translate(-45.78 -139.469)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7120",
    "data-name": "Path 7120",
    d: "M67.037,147.131a2.42,2.42,0,1,0,2.426,2.416A2.419,2.419,0,0,0,67.037,147.131Z",
    transform: "translate(-52.902 -142.366)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11304",
    "data-name": "Group 11304",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_7121",
    "data-name": "Path 7121",
    d: "M24.91,166.6a5.465,5.465,0,0,1-.87-.378,1.924,1.924,0,0,1-.78-2.385,86.92,86.92,0,0,1,4.661-11.314c.644-1.26,1.128-2.6,1.737-3.879a47.364,47.364,0,0,1,4.2-7.18,12.95,12.95,0,0,1,7.892-5.214,19.09,19.09,0,0,1,2.156-.352,1.683,1.683,0,0,1,1.826,2.071,1.223,1.223,0,0,1-1.225.914,13.145,13.145,0,0,0-4.218,1.074,10.091,10.091,0,0,0-3.095,2.216c-1.632,1.692.451,3.286.711,3.66a2.132,2.132,0,0,0,.252.327,12.3,12.3,0,0,1,2.2,2.677,7.323,7.323,0,0,1,.909,2.489,2.325,2.325,0,0,1-.06.945,1.25,1.25,0,0,1-1.044.954c-1.992.375-3.983.756-5.977,1.121a5.155,5.155,0,0,1-.851.006,2.706,2.706,0,0,0,.12.435q1.966,4.238,3.942,8.471a2.013,2.013,0,0,1-1.321,2.946,1.5,1.5,0,0,1-1.78-.705c-.562-1.057-1.08-2.138-1.589-3.222-.86-1.835-1.7-3.68-2.564-5.568-.058.12-.1.21-.144.3-1.195,2.651-2.23,5.364-3.157,8.118a1.985,1.985,0,0,1-1.336,1.473Zm11.662-17.8-1.711,2.258.059.062,2.948-.557Z",
    transform: "translate(-23.124 -135.891)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_7122",
    "data-name": "Path 7122",
    d: "M47.3,146.781a2.614,2.614,0,1,1,2.614,2.612A2.613,2.613,0,0,1,47.3,146.781Z",
    transform: "translate(-32.262 -139.019)",
    fill: "#fff"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrupalIcon);
export default __webpack_public_path__ + "static/media/grupalIcon.3db3b3f92f19db03bdd99f40e09d5867.svg";
export { ForwardRef as ReactComponent };